<template>
  <section class="section points-section dark-bg">
    <div class="container">
      <div class="points">
        <h2 class="title title--invert title--mb">Развиваем ПО на основе задач наших клиентов</h2>
        <p class="text">Мы регулярно выпускаем обновления:</p>
        <ul class="points__list">
          <li
            v-for="(item, index) in list"
            class="points__item"
            :key="`point_${index}`"
            data-aos="fade-right"
            data-aos-duration="800"
            data-aos-delay="0"
          >
            <Approved class="points__icon" />
            <p class="text">{{ item }}</p>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
<script lang="ts" setup>
import Approved from '~/components/icons/vzor/approved.vue';

const list = ['улучшаем производительность,', 'расширяем функциональность,', 'исправляем выявленные ошибки.'];
</script>

<style scoped lang="scss">
@use '~/assets/styles/mixins';

.points {
  &-section {
    overflow: hidden;
    background-image: url('/img/support/rocket.jpg');
    background-repeat: no-repeat;
    background-position: top right;
    background-size: contain;
    min-height: 465px;
    box-sizing: border-box;
    &::before {
      @include mixins.pseudo-elem;
      @include mixins.radial-gradient;
      top: -30%;
      left: -20%;
      width: 50%;
      aspect-ratio: 1 / 1;
      z-index: 1;
    }
    .container {
      position: relative;
      z-index: 1;
      padding-right: 15%;
    }
  }
  &__list {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
  }

  &__item {
    display: flex;
    gap: 5px;
    align-items: center;
  }

  &__icon {
    width: 25px;
    height: 25px;
    fill: var(--accent-color);
  }
}

@media (max-width: 1024px) {
  .points {
    &-section {
      background-image: none;
    }
  }
}
</style>
